import { motion } from "framer-motion";
import { ImagePlus } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { useContent } from "@/lib/content";

const SPANS = [
  "md:col-span-7 md:row-span-2",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-6",
  "md:col-span-6",
];

export default function GallerySection({ id, index, title, subtitle, images }) {
  const list = images || [];
  const c = useContent();
  const text = c[`${id.replace(/-/g, "_")}_subtitle`] ?? subtitle;

  return (
    <section
      id={id}
      data-testid={`section-${id}`}
      className="px-6 md:px-16 py-24 md:py-32 max-w-[1400px] mx-auto"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="flex items-end gap-6 md:gap-10 mb-12 md:mb-16"
      >
        <span className="font-editorial italic text-gold/60 text-3xl md:text-5xl leading-none">{index}</span>
        <div>
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-bone leading-[0.95]">
            {title.toUpperCase()}
          </h2>
          {text && <p className="text-bone/50 text-sm md:text-base mt-2 max-w-xl">{text}</p>}
        </div>
      </motion.div>

      {list.length === 0 ? (
        <div
          data-testid={`gallery-empty-${id}`}
          className="border border-dashed border-[rgba(176,132,51,0.35)] py-20 flex flex-col items-center gap-4 text-bone/40"
        >
          <ImagePlus size={32} className="text-gold/60" />
          <p className="font-display tracking-[0.3em] text-xl">FOTO IN ARRIVO</p>
          <p className="text-sm max-w-md text-center">
            Le immagini di questa sezione saranno caricate a breve.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[240px] md:auto-rows-[260px] gap-5 md:gap-6">
          {list.map((img, i) => (
            <motion.figure
              key={img.id || i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              className={`relative overflow-hidden border border-[rgba(176,132,51,0.15)] group ${
                SPANS[i % SPANS.length]
              }`}
            >
              <img
                src={resolveImg(img.url)}
                alt={`${title} ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.figure>
          ))}
        </div>
      )}
    </section>
  );
}
